import classNames from 'classnames';
import EcoLink from 'eco-design/base/eco-link';
import React from 'react';
import EfLogoIconV1 from '../ef-nav-common/EfLogoIconV1';
import NavToggleIconV1 from '../ef-nav-common/NavToggleIconV1';
import SearchV1 from '../ef-nav-common/SearchV1';
import SearchV1List from '../ef-nav-common/SearchV1/SearchAList';
import StoreV1 from '../ef-nav-common/StoreV1';
import UserV1 from '../ef-nav-common/UserV1';
import LanguageSelection from '../ef-nav-common/LanguageSelection';
import AiSearchUuid from '../ef-nav-common/AiSearchUuid';
import NavList2 from './comps/NavList2';
import { BhHeaderV2Props } from './comps/Props';

import './index.scss';

/**
 *
 * 头部导航-v1
 */
const BhHeaderV2: React.FC<BhHeaderV2Props> = ({ locale, theme, navItems = [], className, TextHeader = {} }) => {
    const prefixCls = `ef-header-v2`;
    const classes = classNames(prefixCls, {
        [`${className}`]: className,
        [`${prefixCls}-theme-${theme}`]: theme,
    });

    return (
        <nav className={classes}>
            <div className={`${prefixCls}-content`}>
                <div className={`${prefixCls}-logo`}>
                    <EcoLink
                        href={`/${locale}`}
                        className={`${prefixCls}-logo-icon GtmModuleData-btn-common`}
                        data-btn-id="logo"
                        dataLayer={{
                            event: 'uaEvent',
                            event_name: 'top_function',
                            button_name: 'Logo',
                            __btn_id1: `${prefixCls}-logo-icon`,
                            __btn_id2: `logo`,
                            __btn_type: 'common',
                        }}
                    >
                        <EfLogoIconV1 />
                    </EcoLink>
                    {/* <span className={`${prefixCls}-logo-line`}></span> */}
                    {/* <span className={`${prefixCls}-logo-msg`}>{TextHeader.logo_title}</span> */}
                </div>

                <NavList2 prefixCls={prefixCls} navItems={navItems} TextHeader={TextHeader} SearchPanel={<SearchV1List prefixCls={prefixCls} />} />

                <div className={`${prefixCls}-bar-list`}>
                    {locale !== 'global' && <SearchV1 prefixCls={prefixCls} />}
                    <UserV1 className="header-v3-user" prefixCls={prefixCls} locale={locale} />
                    <StoreV1 prefixCls={prefixCls} locale={locale} />
                    <NavToggleIconV1 prefixCls={prefixCls} />
                    {locale === 'global' && <LanguageSelection />}
                </div>
            </div>
            <AiSearchUuid />
            {/* <SearchListV2 /> */}
        </nav>
    );
};

export default BhHeaderV2;
